import React, { useContext } from "react";
import "./shared.scss";
import Page from "pages/Page";
import { PageLayout, DownloadLink } from "@sia/style-guide";
import SideBarWithLinks from "components/SideBarWithLinks";
import { useTranslator } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";
import LinkToLogin from "components/LinkToLogin";

export default function AnonymounsUserView() {
  const { language, loginUrl } = useContext(GlobalContext);
  const translate = useTranslator();
  const pageTitle = translate("benchmarking.evaluations.anonymous-user.title");
  const registerUrl = `${loginUrl}#/register`;


  return (
    <Page
      className="landing"
      title={pageTitle}
    >
      <PageLayout variant="layout_25_50_25">
        <div></div>
        <div className="center" lang={language}>
          <h2 className="sia-text-12">{pageTitle}</h2>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">
            {translate("benchmarking.evaluations.anonymous-user.first-paragraph")}
          </div>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">
            {translate("benchmarking.evaluations.anonymous-user.second-paragraph")}
          </div>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">
            {translate("benchmarking.evaluations.anonymous-user.third-paragraph")}
          </div>
          <div className="sia-text-10 sia-padding-03-bottom Localized-Text">
            {translate("benchmarking.evaluations.anonymous-user.fourth-paragraph")}
          </div>
          <LinkToLogin />
          <DownloadLink
            openInCurrentTab
            icon="INTERNAL"
            variant="EXTERNAL"
            href={registerUrl}
            text={translate("benchmarking.landing-page.register.text")}
          ></DownloadLink>
        </div>
        <div className={`right-column ${pageTitle.length > 39 ? "double-height-title" : ""}`}>
          <SideBarWithLinks />
        </div>
      </PageLayout>
    </Page>
  );
}
